module.exports = __webpack_public_path__ + "static/img/point_3.ff837c34.png";